<template>
	<template v-if="userReservations.length">
		<div v-for="reservation in userReservations" :key="reservation.id">
			<PassReservationCard :reservation="reservation"></PassReservationCard>
		</div>
	</template>
	<div v-else>
		<section class="container">
			<div class="section-header">
				No tienes reservas o invitaciones pendientes.
			</div>
		</section>

		<section class="container" v-if="!isValidateUser">
			<div class="section-header">
				Obtén tu QR único y disfruta de múltiples beneficios:
			</div>
			<div class="section-body">
				<ul>
					<li>Haz reservas fácilmente desde tu móvil.</li>
					<li>Accede a la carta digital y realiza pedidos al instante.</li>
					<li>Explora y disfruta de tus restaurantes favoritos.</li>
					<li>Crea momentos inolvidables con tus seres queridos.</li>
				</ul>
			</div>
		</section>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import PassReservationCard from "@/components/passReservationCard/PassReservationCard";

export default {
	data() {
		return {
			contentReservationText: '',
			isValidateUser: false,
		};
	},
	components: {
		PassReservationCard,
	},
	beforeMount() {
		console.log('el usuario antes de montar el container', this.user)
		this.isValidateUser = this.user.type === 2
	},
	mounted() {
		console.log('Todas las reservas desde el contenedor', this.userReservations)
	},
	computed: {
		...mapGetters('user', ['user', 'reserveUrl', 'userReservations', 'latestVenueConfig']),
		...mapGetters('wePass', ['actionParam', 'reservationIdParam']),
	},
	methods: {}
};
</script>
